export const maxPatientAppointmentChangeCutoffHours = 2147483647;

export function parsePatientAppointmentChangeCutoffHours(value: string): number | null | undefined {
  if (value === '') return null;
  if (!/^\d+$/.test(value)) return undefined;

  const numberValue = Number(value);
  return Number.isSafeInteger(numberValue)
    && numberValue <= maxPatientAppointmentChangeCutoffHours
    ? numberValue
    : undefined;
}
